import axios from "axios";
import {logout} from "@/utils/auth";

/**
 * @param type (string) => GET, POST. Obligatorio
 * @param url (string) => URL DEL WS. Obligatorio
 * @param data (array) => PARÁMETROS QUE NECESITA EL WS. Obligatorio
 * @param petition (string) => AJAX, AXIOS. Opcional
 * @param content_type (string) Opcional
 * @param ext (boolean) Opcional
 * @param nlp (boolean) Opcional
 * @returns {Promise}
 */
export async function aicoreBackendPetition(type, url, data, {petition = 'ajax', content_type = 'application/x-www-form-urlencoded; charset=UTF-8', ext = false, nlp = false} = {}) {

    // The BFF holds the service credentials and adds the Authorization header.
    const backend = ext ? 'externos' : (nlp ? 'nlp' : 'aicore');
    const target = '/bff/api/' + backend + '/' + url.replace(/^\/+/, '');
    const headers = {'content-type': content_type, 'X-Requested-With': 'XMLHttpRequest'};

    try {
        switch (petition.toLowerCase()) {
            case 'ajax':
                return await $.ajax({type: type, url: target, data: data, headers: headers});
            case 'axios':
                switch (type.toLowerCase()) {
                    case 'post':
                        return await axios.post(target, data, {headers: headers})
                    case 'get':
                        return await axios.get(target + data, {headers: headers})
                }
        }
    } catch (error) {
        // The BFF answers 401 when the session cookie is missing or expired.
        if ((error?.status ?? error?.response?.status) === 401) logout();
        throw error;
    }
}
